import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { AuthService } from '../../lib/auth/auth.service';
import { User } from '../../lib/user';
import { AuthComponent } from '../component';
import { GlobalEventsManager } from '../../shared/commonmodule/eventmanager';
import { UserTitleComponent } from '../title/title.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { faEnvelope, faKey } from '@fortawesome/free-solid-svg-icons';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-passwordreset',
  imports: [UserTitleComponent,FontAwesomeModule,NgbAlertModule,ReactiveFormsModule, RouterLink],
  templateUrl: './passwordreset.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent extends AuthComponent implements OnInit {
  faKey = faKey;
  codeSend = false;
  form: UntypedFormGroup;

  validations: any = {
    minlengthemailaddress: User.MIN_LENGTH_EMAIL,
    maxlengthemailaddress: User.MAX_LENGTH_EMAIL
  };
  public faEnvelope = faEnvelope;

  constructor(
    authService: AuthService,
    eventsManager: GlobalEventsManager,
    fb: UntypedFormBuilder
  ) {
    super(authService, eventsManager);
    this.form = fb.group({
      emailaddress: ['', Validators.compose([
        Validators.required,
        Validators.minLength(this.validations.minlengthemailaddress),
        Validators.maxLength(this.validations.maxlengthemailaddress)
      ])]
    });
  }

  ngOnInit() {
    this.processing.set(false);
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  sendCode(): boolean {
    this.processing.set(true);
    this.setAlert('info', 'de code wordt verstuurd');

    const emailaddress = this.form.controls.emailaddress.value;

    // this.activationmessage = undefined;
    this.authService.passwordReset(emailaddress).subscribe({
      next: (p: boolean) => {
        this.codeSend = true;
        this.resetAlert();
      },
      error: (e) => {
        this.setAlert('danger', 'het verzenden van de code is niet gelukt: ' + e);
        this.processing.set(false);
      },
      complete: () => this.processing.set(false)
    });
    return false;
  }

}
